export default __webpack_public_path__ + "static/media/services_02.c3b93d61.jpg";